import React from 'react';
import PropTypes from 'prop-types';

import LivestreamFeaturedProducts from '../LivestreamFeaturedProducts';
import LivestreamVideoPlayer from '../LivestreamVideoPlayer';

const LivestreamActiveVideo = ({
  category,
  description,
  isPlayingLive = false,
  products = [],
  title,
  videoId,
  videoType,
  isAdmin = false,
}) => {
  if (!videoId || !videoType) {
    return null;
  }

  return (
    <div className="LivestreamActiveVideo">
      <div className="flex">
        <LivestreamVideoPlayer
          videoId={videoId}
          videoType={videoType}
          fullWidth={!products.length}
        />

        {!!products.length && (
          <div className="ml-12 max-[1023px]:hidden">
            <LivestreamFeaturedProducts products={products} isAdmin={isAdmin} />
          </div>
        )}
      </div>

      <div className="mt-6 pl-5 pr-5 md:pl-[3.333vw] md:pr-[3.333vw] lg:pl-0 lg:pr-0">
        {!!isPlayingLive && (
          <div className="text-xs font-bold items-center text-red inline-flex mb-[5px]">
            <span className="text-2xl font-bold leading-[0] mr-px">&bull;</span>
            LIVE
          </div>
        )}

        {!!title && (
          <h1 className="text-3xl font-bold m-0 text-gray-dark">{title}</h1>
        )}

        {!!category && (
          <div className="text-base font-bold text-gray-light2 mx-0 my-4">
            {category}
          </div>
        )}

        <div className="text-base text-gray mx-0 my-4">{description}</div>
      </div>

      {!!products.length && (
        <div className="lg:hidden">
          <LivestreamFeaturedProducts products={products} isAdmin={isAdmin} />
        </div>
      )}
    </div>
  );
};

LivestreamActiveVideo.propTypes = {
  category: PropTypes.string,
  description: PropTypes.string,
  isPlayingLive: PropTypes.bool,
  products: PropTypes.arrayOf(PropTypes.number),
  title: PropTypes.string,
  videoId: PropTypes.string,
  videoType: PropTypes.oneOf(['vimeo', 'wistia']),
  isAdmin: PropTypes.bool,
};

export default LivestreamActiveVideo;
